/**
 * Created by TzuHsing on 2020-02-16
 */
import React, { Component } from 'react'
import { Button, message } from 'antd'
import noImg from '../../../assert/images/noimg.svg'
import { IMAGE_DOMAIN } from '../../../config'
class AdvPreview extends Component {
  componentDidMount() {
    this.props.fetchUnionList()
  }
  handleNoImg = (e) => {
    e.target.onError = null
    e.target.src = noImg
  }
  handleReload = () => {
    const { clubId, fetchUnionList, getAdvInfo } = this.props
    getAdvInfo(clubId, 3)
    fetchUnionList()
    message.success('操作成功!')
  }
  handleTurnToLink = (link) => {
    const newWindow = window.open('about:blank')
    newWindow.location.href = link
  }
  getPreViewContent = (list, title) => {
    return (
      <React.Fragment>
        {list && list.length === 0 ? (
          ''
        ) : (
          <div className="advPreviewList">
            <h4 className="advPreviewTitle">{title}</h4>
            {list &&
              list.map((item, idx) => {
                return (
                  <div className="advManageCardBox advPreviewCard" key={idx}>
                    <div className="advItemImg">
                      <img
                        src={`${IMAGE_DOMAIN}${item.image_url}`}
                        alt="adv_img"
                        onError={this.handleNoImg}
                      />
                    </div>
                    <div className="advItemContent">
                      <div className="advItemText">{item.title}</div>
                      <div className="advItemBottom">
                        <div className="advItemPrice">
                          限时特价:{' '}
                          <span>
                            &yen;{' '}
                            {item.price.length > 7
                              ? item.price.slice(0, 7)
                              : item.price}
                          </span>
                        </div>
                        <Button
                          size="small"
                          className="advItemButton"
                          onClick={() => this.handleTurnToLink(item.url)}
                        >
                          去抢购
                        </Button>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        )}
      </React.Fragment>
    )
  }
  render() {
    const { advUnionList, advClubList, clubId } = this.props
    const UnionList = clubId === '0' ? advClubList : advUnionList
    return (
      <div className="advPreview">
        <div className="advManageHeader">
          <div className="advManageTitle">发布预览</div>
          <a onClick={() => this.handleReload()} className="advManageLink">
            刷新
          </a>
        </div>
        <div className="advPreviewContent">
          {this.getPreViewContent(UnionList, '联盟优惠')}
          {+clubId === 0
            ? ''
            : this.getPreViewContent(advClubList, '俱乐部特供')}
        </div>
      </div>
    )
  }
}

export default AdvPreview



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/components/AdvPreview.js